import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadTOHistoryListStatus: 'idle',
    loadTOHistoryListError: undefined as any,
    loadTOHistoryListLastArgs: undefined as any,
    loadTOHistoryStatus: 'idle',
    loadTOHistoryError: undefined as any,
    saveTOHistoryStatus: 'idle',
    saveTOHistoryError: undefined as any,
    deleteTOHistoryStatus: 'idle',
    deleteTOHistoryError: undefined as any,

    tOHistoryList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadTOHistoryList = createAsyncThunk('toPruefungsartTOHistorySlice/loadTOHistoryList', async ({ gridFilters, globalFilters, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().toPruefungsartTOHistorySlice.loadTOHistoryListLastArgs
    if (_.isEqual(lastArgs, { gridFilters, globalFilters }) && !forceReload) { return }

    let promises = []
    {
        const [url, params] = prepParams(`/api/ixweb/nuristohistory/`, globalFilters)
        promises.push(client.get(
            url,
            {
                params,
            }
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { gridFilters, globalFilters }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadTOHistoryListStatus } = getState().toPruefungsartTOHistorySlice
        return loadTOHistoryListStatus !== 'pending'
    }
})

export const loadTOHistory = createAsyncThunk('toPruefungsartTOHistorySlice/loadTOHistory', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/nuristohistory/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadTOHistoryStatus } = getState().toPruefungsartTOHistorySlice
        return loadTOHistoryStatus !== 'pending'
    }
})

export const saveTOHistory = createAsyncThunk('toPruefungsartTOHistorySlice/saveTOHistory', async ({ tOHistory }: any, { rejectWithValue }: any) => {
    let promises = []
    if (tOHistory?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/nuristohistory/${ tOHistory?.HDR_ID }/`,
            prepareData(tOHistory),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/nuristohistory/`,
            prepareData(tOHistory),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveTOHistoryStatus } = getState().toPruefungsartTOHistorySlice
        return saveTOHistoryStatus !== 'pending'
    }
})

export const deleteTOHistory = createAsyncThunk('toPruefungsartTOHistorySlice/deleteTOHistory', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/nuristohistory/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteTOHistoryStatus } = getState().toPruefungsartTOHistorySlice
        return deleteTOHistoryStatus !== 'pending'
    }
})

const TOHistorySlice = createSlice({
    name: 'toPruefungsartTOHistorySlice',
    initialState,
    reducers: {
        resetloadTOHistoryListError: (state) => {
            state.loadTOHistoryListError = undefined
        },
        resetloadTOHistory: (state) => {
            state.formItem = undefined
            state.loadTOHistoryError = undefined
        },
        resetloadTOHistoryError: (state) => {
            state.loadTOHistoryError = undefined
        },
        resetsaveTOHistory: (state) => {
            state.formItem = undefined
            state.saveTOHistoryError = undefined
        },
        resetsaveTOHistoryError: (state) => {
            state.saveTOHistoryError = undefined
        },
        resetdeleteTOHistoryError: (state) => {
            state.deleteTOHistoryError = undefined
        },
        removeFromTOHistoryListById: (state, action) => {
            state.tOHistoryList = state.tOHistoryList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromTOHistoryListByIds: (state, action) => {
            state.tOHistoryList = state.tOHistoryList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.tOHistoryList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadTOHistoryListStatus = 'preloaded'
            state.loadTOHistoryListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.tOHistoryList = []
            state.loadTOHistoryListStatus = 'idle'
            state.loadTOHistoryListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadTOHistoryList.pending, (state) => {
            state.loadTOHistoryListStatus = 'pending'
            state.loadTOHistoryListError = undefined
        })
        builder.addCase(loadTOHistoryList.fulfilled, (state, action) => {
            state.loadTOHistoryListStatus = 'idle'

            if (!action.payload) { return }

            state.loadTOHistoryListLastArgs = action.payload.args

            {
                state.tOHistoryList = action.payload.data

            }
        })
        builder.addCase(loadTOHistoryList.rejected, (state, action) => {
            state.loadTOHistoryListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadTOHistoryListError = action.error.message
            } else {
                state.loadTOHistoryListError = action.payload
            }
        })

        builder.addCase(loadTOHistory.pending, (state) => {
            state.loadTOHistoryStatus = 'pending'
            state.loadTOHistoryError = undefined
        })
        builder.addCase(loadTOHistory.fulfilled, (state, action) => {
            state.loadTOHistoryStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.tOHistoryList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.tOHistoryList.push(newItem) }
                else { state.tOHistoryList[i] = { ...state.tOHistoryList[i], ...newItem } }
            }
        })
        builder.addCase(loadTOHistory.rejected, (state, action) => {
            state.loadTOHistoryStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadTOHistoryError = action.error.message
            } else {
                state.loadTOHistoryError = action.payload
            }
        })

        builder.addCase(saveTOHistory.pending, (state) => {
            state.saveTOHistoryStatus = 'pending'
            state.saveTOHistoryError = undefined
        })
        builder.addCase(saveTOHistory.fulfilled, (state, action) => {
            state.saveTOHistoryStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.tOHistoryList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.tOHistoryList.push(newItem) }
                else { state.tOHistoryList[i] = { ...state.tOHistoryList[i], ...newItem } }
            }
        })
        builder.addCase(saveTOHistory.rejected, (state, action) => {
            state.saveTOHistoryStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveTOHistoryError = action.error.message
            } else {
                state.saveTOHistoryError = action.payload
            }
        })

        builder.addCase(deleteTOHistory.pending, (state) => {
            state.deleteTOHistoryStatus = 'pending'
            state.deleteTOHistoryError = undefined
        })
        builder.addCase(deleteTOHistory.fulfilled, (state, action) => {
            state.deleteTOHistoryStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.tOHistoryList = state.tOHistoryList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.tOHistoryList = state.tOHistoryList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteTOHistory.rejected, (state, action) => {
            state.deleteTOHistoryStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteTOHistoryError = action.error.message
            } else {
                state.deleteTOHistoryError = action.payload
            }
        })

    }
})

export const {
    resetloadTOHistoryListError,
    resetloadTOHistory,
    resetloadTOHistoryError,
    resetsaveTOHistory,
    resetsaveTOHistoryError,
    resetdeleteTOHistoryError,
    removeFromTOHistoryListById,
    removeFromTOHistoryListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = TOHistorySlice.actions
export default TOHistorySlice.reducer
